'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var animate_1 = require("./animate");
function scrollToElem(to, ms) {
    return new Promise(function (resolve, reject) {
        var start = window.pageYOffset;
        var end = window.pageYOffset + to.getBoundingClientRect().top;
        var getCalc = function (from, to) { return function (perc) { return (from - to) * (1 - perc) + to; }; };
        var calc = getCalc(start, end);
        return resolve({
            duration: ms,
            timing: animate_1.linear,
            draw: function (progress) {
                window.scrollTo(window.pageXOffset, calc(progress));
            }
        });
    })
        .then(function (animation) { return animate_1.animate(animation); });
}
exports.scrollToElem = scrollToElem;
